import React, { useState } from 'react';

const AddCustomer = () => {
  const [formData, setFormData] = useState({
    profileImage: null,
    mobile: '',
    name: '',
    email: '',
    address: '',
    gender: '',
    dob: '',
    anniversary: '',
  });

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted:', formData);
    // Handle form submission (API or logic)
  };

  return (
    <div className="flex items-center justify-center min-h-screen  p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white  rounded-lg p-6 w-full max-w-lg space-y-4"
      >
        {/* Profile Picture */}
        <div className="flex flex-col items-center space-y-2">
          <label htmlFor="profileImage" className="cursor-pointer">
            {formData.profileImage ? (
              <img
                src={URL.createObjectURL(formData.profileImage)}
                alt="Preview"
                className="w-24 h-24 rounded-full object-cover"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-gray-300 flex items-center justify-center text-gray-600">
                Upload
              </div>
            )}
          </label>
          <input
            id="profileImage"
            name="profileImage"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleChange}
          />
        </div>

        {/* Mobile Number */}
        <input
          type="tel"
          name="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
          required
        />

        {/* Name */}
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
          required
        />

        {/* Email */}
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
        />

        {/* Address */}
        <textarea
          name="address"
          placeholder="Address"
          value={formData.address}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
        />

        {/* Gender */}
        <div className="flex items-center space-x-6">
          <label className="flex items-center">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleChange}
              className="mr-2"
            />
            Male
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleChange}
              className="mr-2"
            />
            Female
          </label>
        </div>

        {/* DOB */}
         <label className="flex items-center">
        <input
          type="date"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          className="w-full border rounded px-3 py-2"
          placeholder="Date of Birth"
        />
</label>
      

        {/* Save Button */}
        <button
          type="submit"
          className="w-full bg-primary text-white py-2 px-4 rounded hover:bg-red-700 transition"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default AddCustomer;
